module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('industries', {
    scopedSlots: _vm._u([{
      key: "hero",
      fn: function() {
        return [_c('Hero', {
          attrs: {
            "imageName": "industries/industries-banner.jpg",
            "altText": "American Credit Business Loans"
          }
        }, [
          [_c('h1', [_vm._v("Industries Served")]), _vm._v(" "), _c('p', [_vm._v("\n          Just when business is going great, life hits you hard. Luckily, we\n          hit back harder. American Credit offers\n          "), _c('strong', [_vm._v("equipment loans, working capital loans, and invoice\n            financing")]), _vm._v("\n          to get you back on your feet and back to work asap. "), _c('br'), _c('br'), _vm._v("\n          Browse through our most served industries, and learn how we assist\n          business owners "), _c('strong', [_vm._v("just like you")]), _vm._v(", everyday.\n        ")]), _vm._v(" "), _c('router-link', {
            staticClass: "cta",
            attrs: {
              "to": "/get-start?step=1",
              "tag": "button"
            }
          }, [_vm._v("Get a quote")])]
        ], 2)]
      },
      proxy: true
    }, {
      key: "grid-section",
      fn: function() {
        return [_c('IndustriesGrid', {
          attrs: {
            "gridElements": _vm.industriesGrid
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function() {
              return [_c('span', [_vm._v("Browse")]), _vm._v(" Our Industries")]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "first-row",
      fn: function() {
        return [_c('RowSection', {
          staticClass: "lei-section",
          attrs: {
            "img-side": "right",
            "imageName": "industries/Lei-li-formal.jpeg",
            "altText": "photo Dr. Lei Li, CEO of American Credit, Inc., in blue suit smiling"
          },
          scopedSlots: _vm._u([{
            key: "content",
            fn: function() {
              return [_c('h2', [_c('span', [_vm._v("American Credit:")]), _vm._v(" The Difference You Can Trust")]), _vm._v(" "), _c('p', [_vm._v("\n          Your business is not JUST a business. It’s YOURS. It’s your\n          livelihood. It’s your passion. American Credit completely\n          understands this. We help business owners just like you everyday, by\n          taking a wholistic approach to business financing.\n          "), _c('strong', [_vm._v("Dr. Lei Li, PhD, CFA, & CEO of American Credit")]), _vm._v(", is\n          an Economist who uses his 20+ years of industry experience to help\n          business owners achieve their American Dream:\n          "), _c('strong', [_vm._v("successful business ownership")]), _vm._v(". "), _c('br'), _c('br'), _vm._v("\n          Whatever financial situation you’re in, American Credit has your\n          back. Apply for your business loan today!\n        ")])]
            },
            proxy: true
          }, {
            key: "button-contact",
            fn: function() {
              return [_c('contact-info', {
                staticClass: "d-none d-md-flex",
                attrs: {
                  "imageName": "Lei_Li.png",
                  "altText": "Lei's photo",
                  "title": "Call Lei",
                  "contactType": "Service",
                  "phoneNumber": "650-885-8055"
                }
              })]
            },
            proxy: true
          }])
        })]
      },
      proxy: true
    }, {
      key: "google-reviews",
      fn: function() {
        return [_c('div', {
          staticClass: "elfsight-app-8279c03d-9a65-4465-b949-ecb8d18697e0"
        })]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2731e29e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/industries.vue
// module id = 1943
// module chunks = 5